import { toast } from 'react-toastify'

const defaultOptions = {
  autoClose: 2500,
  hideProgressBar: true
}

// types: success, info, warn, error
function show(type, message, options) {
  const toastOptions = !options ? defaultOptions : options
  toast[type](message, toastOptions)
}

export default { show }
